// 请保证所有语言包 的Key值都一直

export default {
  login: {
    username: "username",

    password: "password",
  },

  menu: {
    Menu_ItemList: "List of Items",

    Menu_ToDoList: "ToDo List",

    Menu_Drafts: "Drafts",
  },

  common: {
    close: "Close",
    add: "Add",
    confirm: "Confirm",
    delete: "Delete",
    uploadOnlyOne: "Only one file can be uploaded",
    ploadExcelFormat: "Please upload an Excel file (.xls or .xlsx)!",
    uploadMaxSize: "The uploaded file size must not exceed 30MB!",
    welcome: "Welcome",

    upload: "Upload",

    download: "Download",

    save: "Save",

    saveDraft: "Save as draft",

    submit: "Submit",

    view: "View",

    edit: "Edit",

    search: "Search",

    reset: "Reset",

    export: "Export",

    discard: "Discard",

    audit: "Audit",

    preReturnBtn: "Return",

    uploadtip: "Max 30M",
    downloadTemplate: "Download Template",
  },

  message: {
    level2Required: "Please select the second-level partner",
    unbound:
      "Your account is NOT linked to a valid partner contract. Please ensure that the partner contract is still active and the account is bound. If you have any questions, please contact Ruijie Sales.",

    prompt: "Please enter at least two characters.",

    registrationNo: "Enter Registration No.",

    hints:
      "If the project tender has been lost or the project no longer requires protection, please click to discard the project.",

    deleteConfirm: "Are you sure you want to delete?",

    discardConfirm: "Are you sure you want to discard?",

    cancel: "Cancel",

    comfirm: "Confirm",

    deletesuccess: "Deleted successfully",
    setDepartment: "Please contact the administrator to set up the department",

    operation: "Operation",

    queryResult: "Query result",

    needPartnerName: "Please enter the company name",

    needProjectName: "Please enter the project name",

    needRuijieSaleName1: "Please enter the Ruijie sales",

    needCountry: "Please enter the country of the project",

    needFinalCompanyName: "Please enter the company name of the end user",

    needFinalCompanyAddress: "Please enter the project implementation address",

    needFinalUserName: "Please enter the project decision maker",

    needFinalUserPosition: "Please enter the job title of the decision maker",

    needFinalUserTel: "Please enter the phone number of the decision maker",

    needFinalUserEmail: "Please enter the email of the decision maker",

    needFundsInPlace: "Please select whether the funds are in place",

    needProjectBudget: "Please enter the overall project budget",

    needNetworkBudget: "Please enter the network product budget",

    needPurchaseTime: "Please select the procurement date",

    needExpectedOrderDate: "Please select the expected order date",

    needIsSupportRuijie:
      "Please select whether the end user project leader supports Ruijie",

    needHasCooperated:
      "Please select whether have some business with this end user before",

    needRuijieSaleName: "Please select the Ruijie sales",

    needProjectRequirements: "Please enter the user project requirements",

    needEmail: "Please enter the email",

    needBeEmail: "Please enter the correct email format",

    needPartnerEmail: "Please enter the partner email",

    needPartnerContactName: "Please enter the partner contact name",

    needPartnerPhone: "Please enter the partner phone",

    needJointVisit: "Please select the Joint visit",

    needProjectPhase: "Please select the Project stage",

    unitOfCash: "USD",

    saveSuccess: "Save Successful",

    submitSuccess: "Submit Successful",

    submitError: "Submit Failed",

    select: "Please Select",

    agree: "Agree",

    reject: "Reject",

    rejectToFirst: "Reject to the first step",

    needOpinion: "Please enter the reason of approval",

    needDiscardReason: "Please enter the reason of discard",

    discardSuccess: "Discarded successfully",

    clause: "Ruijie International Partner Project Protection Terms",

    close: "Close",

    readAndAgree:
      "I have read and agree to the Ruijie International Partner Project Protection Terms.",

    pleaseReadAndAgreeClause:
      "Please read and agree to the Ruijie International Partner Project Protection Terms.",

    budgetMaxValue: "Budget should not exceed 12 digits",

    budgetNotAllow: "Please enter a positive number within 12 bits.",

    budgetCantNegative: "Budget amount cannot be negative",

    needNumberType: "Please enter a number type",

    enterProjectName: "Enter the project name for query",

    enterFinalUserName: "Enter the project decision maker for query",

    enterFinalCompanyAddress:
      "Enter the project implementation address for query",

    approver: "Approver",

    logout: "Logout",

    restrictionPrompt:
      "Tips: Upload the data using the provided Excel template. The file size cannot exceed 30 MB. The system will automatically identify the file data, and you can make changes to the data later.",
  },

  page: {
    drafts: "Drafts",

    addProject: "Add project",

    exportProduct: "export product",

    uploadButtonMessage1: "Drag files here, or",
    uploadButtonMessage2: "Click to upload",

    list: "Project List",

    todoList: "Pending Process List",

    projectSearch: "Search Registered Project",

    prmNew: {
      title: "New project",

      partnerName: "Company Name",

      projectName: "Project Name",

      country: "Country/Region",

      finalCompanyName: "End-User Company Name",

      finalCompanyAddress: "Project Implementation Address",

      finalUserName: "Project decision maker",

      finalUserPosition: "Job title of the decision maker",

      finalUserTel: "Phone number of the decision maker",

      finalUserPhone: "Mobile number of the end user project leader",

      finalUserEmail: "Email of the decision maker",

      fundsInPlace: "Are the funds in place?",

      projectBudget: "Overall project budget",

      networkBudget: "Network Product Budget",

      expectedOrderDate: "Expected Order Date",

      isSupportRuijie: "Does the end user project leader support Ruijie?",

      ruijieSaleName: "Ruijie Sales",

      hasCooperated: "Did you have any business with this end user before?",

      projectPhase: "Project Step",

      projectPhases: "Which step is this project at",

      expctedOrderDate: "Expected Order Date",

      lastUpdata: "Last Update",

      projectProgressUpdate: "Project progress update",

      projectRequirements: "User project requirements",

      budgetFrom: "Where is the budget from?",

      executiveDepartment:
        "Which department did or will initiate this project?",

      participatingDepartment:
        "Which department did or will join this project?",

      dockingPeople: "Who can be our consultant or supporter , what title?",

      competitorSituation: "Competitive situation",

      beforeSell: "What products did you sell to this end user before",

      projectAttachment: "Ruijie Product Bom list of this project",

      projectAttachmentDetail: "Ruijie product Bom list of this project ",

      partnerEmail: "Partner Email",

      partnerContactName: "Partner Contact Name",

      partnerPhone: "Partner Phone",

      projectContractor: "Project Contractor",

      relatedRAP: "Related RAP",

      jointVisit: "Able to arrange joint visit?",

      fillFullName: "Please fill in the full name , do not abbreviate",
    },

    prmList: {
      projectStep: "Project Step",

      registration: "Registration No.",

      partnerName: "Company Name",

      projectName: "Project Name",

      country: "Country/Region",

      taxNumber: "Tax Number",

      ruijieSaleName: "Sales",

      approvalState: "Approval State",

      prmState: "Status",

      discardReason: "Discard Reason",

      // showClause: 'View the instructions for the report',

      showClauseSBG: "View the instructions for the SBG report",

      showClauseEBG: "View the instructions for the EBG report",

      applicant: "Applicant",

      submitTime: "Submit Date",

      createTime: "Create Date",

      expireTime: "Expiry Date",
    },

    prmDetail: {
      contentTitle: "Project Info",

      approvalTitle: "Approval Process",

      approvalNode: "Approval Node",

      operator: "Operator",

      auditStatus: "Status",

      approvalDate: "Date of Approval",

      approvalRemarks: "Remarks of Approval",

      operatorLogTitle: "Operation log",

      operation: "Operational content",

      fieldName: "Field Name",

      oldValue: "Old Value",

      newValue: "New Value",

      updateTime: "Update Time",

      operationType: "Operation type",

      endUserInfo: "End User Info",

      partnerInfo: "Partner Info",
    },

    prmEdit: {
      title: "Edit",
    },

    prmAudit: {
      title: "Review",

      remarksApproval: "Remarks of Approval",
    },

    prmView: {
      title: "View",
    },

    ProjectSearch: {
      result: "Result",

      country: "Country/Region",

      sales: "Sales",

      email: "Email",
    },
  },
};
